import React from "react";
import { ChevronDown } from "lucide-react";

export default function FaqAccordion({ items = [] }) {
  const [open, setOpen] = React.useState(null);
  return (
    <div className="grid gap-3" data-testid="faq-accordion">
      {items.map((it, i) => (
        <div key={i} className="bg-white rounded-2xl border border-lc overflow-hidden">
          <button
            onClick={() => setOpen(open === i ? null : i)}
            className="w-full px-5 py-5 flex items-center justify-between text-left gap-3"
            data-testid={`faq-trigger-${i}`}
          >
            <span className="font-semibold text-dark text-[15px] lg:text-base">{it.q}</span>
            <ChevronDown size={18} className={`transition-transform ${open === i ? "rotate-180" : ""} text-dark/60`} />
          </button>
          {open === i && (
            <div className="px-5 pb-5 text-dark/75 text-[15px] leading-relaxed border-t border-lc/60 pt-3" data-testid={`faq-content-${i}`}>{it.a}</div>
          )}
        </div>
      ))}
    </div>
  );
}
